<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AZ7x4e/tc-custom/9780802198716.jpg?1726519075607" alt="This image is the cover for the book Passion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passion
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author interweaves the destinies of Napoleon’s cook and an enigmatic Venetian woman in this “arresting, elegant novel” (<i>Publishers Weekly</i>).</b><br/><br/> A faithful soldier of the<i> Grande Armée</i>, Henri is given the honor of serving meals to Napoleon himself. After all, Henri is short—and no one over five-foot-two ever serves the emperor. But when following his revered leader brings him to near-starvation in Russia’s frozen winter, Henri is disillusioned and desperate for escape.<br/><br/> The web-footed daughter of a Venetian boatman, Villanelle has long been acquainted with the advantages of dishonesty. Trust hasn’t been her strong suit since her heart was stolen—literally—by a noblewoman she once loved.<br/><br/> Soon these two will meet their shared destiny in the chaotic carnival that is early 19th century Venice. In <i>The Passion</i>, Whitbread Award-winning author Jeanette Winterson delivers a “historical novel quite different from any other” (<i>Vanity Fair</i>).<br/><br/> “Recalls García Márquez . . . Magical touches dance like highlights over the brilliance of this fairy tale about passion, gambling, madness, and androgynous ecstasy.” —Edmund White
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeanette Winterson
      </h2>
      
      <p class="authorDescription body article">Born in Manchester, England, Jeanette Winterson is the author of seventeen books, including the national bestseller <I>Why Be Happy When You Could Be Normal?</I>, <I>Oranges Are Not the Only Fruit</I>, and <I>The Passion</I>. She has won many prizes including the Whitbread Award for Best First Novel, the John Llewellyn Rhys Prize, the E. M. Forster Award, and the Stonewall Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?adfecab4